<template>
  <div class="applymanage">
    <div class="toolbar">
      <el-input placeholder="请输入单位名称....." v-model="params.companyName" @keyup.enter.native="loadTableData(1)" class="input-with-select" maxlength="20">
        <el-select v-model="params.status" slot="prepend" placeholder="请选择" @change="loadTableData(1)">
          <el-option label="全部" value=""></el-option>
          <el-option label="未处理" value="1"></el-option>
          <el-option label="已处理" value="2"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" class="btn_main_color" @click="loadTableData(1)" @keyup.enter.native="loadTableData(1)"></el-button>
      </el-input>
    </div>
    <div class="content_wrapper">
      <el-table
        v-loading="loading"
        :data="tableData"
        header-row-class-name="header-row-class-name"
        border
        :height="height"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          label="单位名称"
          align="center"
          prop="companyName"
          min-width="20%">
        </el-table-column>
        <el-table-column
          label="联系人"
          align="center"
          prop="contactsName"
          min-width="15%">
        </el-table-column>
        <el-table-column
          label="联系电话"
          align="center"
          prop="contactsPhone"
          min-width="15%">
        </el-table-column>
        <el-table-column
          label="申请时间"
          align="center"
          prop="createdTime"
          width="160">
        </el-table-column>
        <el-table-column
          label="状态"
          align="center"
          width="100">
          <template slot-scope="scope">
            {{scope.row.status === 1 ? '未处理' : '已处理'}}
          </template>
        </el-table-column>
        <el-table-column
          label="留言"
          align="left"
          min-width="20%"
          prop="message"
          >
        </el-table-column>
        <el-table-column
          label="备注"
          align="left"
          min-width="20%"
          prop="remark"
          >
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          width="110"
          label="操作">
          <template slot-scope="scope">
            <el-button class="btn_other" size="small" @click="editApply(scope.row)">备注一下</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        class="my-pagination"
        @size-change="handleSizeChange"
        :current-page="params.pageNumber"
        @current-change="loadTableData"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 编辑框 -->
    <edit-dialog  v-if="applyDialogVisible" :dataform="rowData" @success="editSuccess" @hide="applyDialogVisible= false"></edit-dialog>
  </div>
</template>
<script type="text/babel">
import editDialog from './edit-dialog'
import devService from '@/service/devService'
export default {
  components: {
    editDialog: editDialog
  },
  data () {
    return {
      loading: false,
      params: {
        status: '',
        companyName: '',
        pageNumber: 0,
        pageSize: 20
      },
      total: 0,
      rowData: {},
      height: this.SysConstant.winHeight - 310,
      applyDialogVisible: false,
      tableData: []
    }
  },
  mounted () {
    this.loadTableData()
  },
  methods: {
    editApply (row) {
      this.rowData = row
      this.applyDialogVisible = true
    },
    editSuccess (remark) {
      this.applyDialogVisible = false
      this.$message.success(this.SysConstant.success)
      // this.rowData.remark = remark

      this.loadTableData()
    },
    // 加载表格数据
    async loadTableData (pageNumber = 1) {
      // 直接操作数据
      this.loading = true
      this.params.pageNumber = pageNumber
      try {
        let data = await devService.listApplyUser(this.params)
        if (data && data.content) {
          this.tableData = data.content
          this.total = data.totalElements
        } else {
          this.tableData = []
          this.total = 0
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    async handleSizeChange (val) {
      this.params.pageSize = val
      await this.loadTableData(this.params.pageNumber)
    }
  }
}
</script>
<style scoped>
  .applymanage {
    padding: 15px 10px;
  }
  .applymanage .toolbar{
    height: 74px;
    line-height: 74px;
    margin-bottom: 20px;
    padding-right:10px;
    text-align: right;
    background-color: #ffffff;
  }
  .applymanage .toolbar .el-select {
    width: 130px;
  }
  .applymanage .content_wrapper{
    background-color: #ffffff;
    padding: 30px 10px 20px 20px;
  }
  .applymanage .toolbar .input-with-select{
    width: 400px;
  }
</style>
<style type="text/css">

  .applymanage .toolbar .el-input-group__append{
    background-color: #00AAFF;
    border: 1px solid #00AAFF;
    color: #ffffff;
    font-size: 16px;
  }
  .applymanage .content_wrapper .my-pagination{
    height: 50px;
    line-height: 50px;
  }
  .applymanage .my-pagination *{
    color: #333333;
  }
  .applymanage .my-pagination {
    border:solid 1px #DFE5F0;
    border-top: none;
    padding-left: 20px;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/applyuser-manage/index.vue